import React, { useState } from "react";

function Navbar({ theme, setTheme }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  const navLinks = [
    { name: "Home", href: "#home" },
    { name: "About & Tech Stack", href: "#about" },
    { name: "Software Track Record", href: "#enterprise-track-record" },
    { name: "Software Products", href: "#portfolio" },
    { name: "Ecosystems", href: "#clients" },
    { name: "Tech Insights", href: "#blog" },
    { name: "API Contact", href: "#contact" }
  ];

  return (
    <nav className="sticky top-0 left-0 z-50 flex w-full items-center bg-slate-950 border-b border-emerald-500/30 shadow-2xl shadow-emerald-500/10 transition-all duration-300">
      <div className="container mx-auto px-4">
        <div className="relative flex items-center justify-between py-3.5">
          {/* Logo & Live System Status Badge */}
          <div className="flex items-center gap-3">
            <a href="#home" className="flex items-center gap-2 group">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-emerald-500 to-teal-600 text-slate-950 font-black font-mono text-sm shadow-md shadow-emerald-500/20 transition-transform group-hover:scale-110">
                💻
              </span>
              <div className="flex flex-col">
                <span className="text-base font-black tracking-wider text-slate-100 font-mono">
                  M.HAIDAR <span className="text-emerald-400">SHAHAB</span>
                </span>
                <span className="text-[10px] font-mono font-bold text-emerald-500/90 uppercase tracking-widest">
                  SENIOR FULL-STACK SOFTWARE ENGINEER
                </span>
              </div>
            </a>

            <div className="hidden sm:flex items-center gap-2 px-3 py-1 rounded-full bg-slate-900 border border-emerald-500/30 text-[10px] font-mono font-bold text-emerald-400">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
                <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" />
              </span>
              <span>SYSTEM ONLINE</span>
            </div>
          </div>

          {/* Nav Links & Mobile Toggle */}
          <div className="flex items-center gap-4">
            <button
              onClick={toggleMenu}
              type="button"
              className="block lg:hidden focus:outline-none p-2 rounded-xl bg-slate-900 border border-emerald-500/30 text-emerald-400 transition-colors"
              aria-label="Toggle navigation menu"
            >
              <span className={`hamburger-line block h-0.5 w-6 bg-emerald-400 my-1 transition duration-300 ease-in-out ${isMenuOpen ? "rotate-45 translate-y-1.5" : ""}`} />
              <span className={`hamburger-line block h-0.5 w-6 bg-emerald-400 my-1 transition duration-300 ease-in-out ${isMenuOpen ? "opacity-0" : ""}`} />
              <span className={`hamburger-line block h-0.5 w-6 bg-emerald-400 my-1 transition duration-300 ease-in-out ${isMenuOpen ? "-rotate-45 -translate-y-1.5" : ""}`} />
            </button>

            <div
              className={`absolute right-4 top-full ${
                isMenuOpen ? "block animate-fade-in" : "hidden"
              } w-full max-w-[280px] rounded-2xl bg-slate-950/95 py-6 px-4 shadow-2xl border border-emerald-500/40 backdrop-blur-2xl lg:static lg:block lg:max-w-full lg:rounded-none lg:bg-transparent lg:p-0 lg:shadow-none lg:border-none`}
            >
              <ul className="flex flex-col lg:flex-row lg:items-center gap-1 lg:gap-2">
                {navLinks.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      onClick={closeMenu}
                      className="px-3.5 py-2 rounded-xl text-xs font-mono font-bold text-slate-300 hover:text-emerald-400 hover:bg-slate-900/80 border border-transparent hover:border-emerald-500/20 transition-all duration-200 block"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
